import { get } from '../utils/axios'

export const getEmpsStatusAPI = async () => {
  return await get('status')
}
